import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { EventAdditionalApi } from 'api';

function useGet(id: string) {
  return useAuthQuery(
    getQueryKeys([KEY]).detail(id),
    () => EventAdditionalApi.get(id),
    {
      select: (data) => data.data,
      enabled: !!id,
    },
  );
}

export default useGet;
